module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp",
    attrs: {
      "id": "client-form"
    }
  }, [_vm._m(0, false, false), _c('div', {
    staticClass: "mdl-card__supporting__text"
  }, [_c('div', {
    ref: "tabs",
    staticClass: "mdl-tabs mdl-js-tabs mdl-js-ripple-effect"
  }, [_vm._m(1, false, false), _c('div', {
    ref: "properties",
    staticClass: "mdl-tabs__panel is-active",
    attrs: {
      "id": "properties"
    }
  }, [_c('v-properties')], 1), _c('div', {
    ref: "statistics",
    staticClass: "mdl-tabs__panel",
    attrs: {
      "id": "statistics"
    }
  }, [_c('div', {
    staticClass: "mdl-card"
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text"
  }, [_c('v-statistics')], 1)])]), _c('div', {
    ref: "activities",
    staticClass: "mdl-tabs__panel",
    attrs: {
      "id": "activities"
    }
  }, [_c('v-activities')], 1), _c('div', {
    ref: "table",
    staticClass: "mdl-tabs__panel",
    attrs: {
      "id": "tables"
    }
  }, [_c('v-table')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title"
  }, [_c('div', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Administration")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-tabs__tab-bar"
  }, [_c('a', {
    staticClass: "mdl-tabs__tab is-active",
    attrs: {
      "href": "#properties"
    }
  }, [_vm._v("Klientuppgifter")]), _c('a', {
    staticClass: "mdl-tabs__tab",
    attrs: {
      "href": "#statistics"
    }
  }, [_vm._v("Statistik")]), _c('a', {
    staticClass: "mdl-tabs__tab",
    attrs: {
      "href": "#activities"
    }
  }, [_vm._v("Aktiviteter")]), _c('a', {
    staticClass: "mdl-tabs__tab",
    attrs: {
      "href": "#tables"
    }
  }, [_vm._v("Tabell")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b7f229a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Administration.vue
// module id = 536
// module chunks = 1